const misc = {
  chunk: (array, chunkSize) => Array(Math.ceil(array.length / chunkSize))
    .fill()
    .map((_, i) => i * chunkSize)
    .map(start => array.slice(start, start + chunkSize)),
  decode: html => {
    var textArea = document.createElement("textarea");
    textArea.innerHTML = html;
    return textArea.value;
  },
  position: (row, col, cols) => row * cols + col,
  coordinates: (position, cols) => ({
    row: Math.floor(position/cols),
    col: position % cols
  }),
  pad: (number, length) => `${number}`.padStart(length, '0'),
  empty: object => object === null
    || object === undefined
    || !Object.keys(object).length,
  map: (object, modify) => {
    if (object === null || object === undefined) return object;
    return Object.fromEntries(
      Object.entries(object)
        .map(([key, value]) => [key, modify(value)])
    );
  }
};

export default misc;
